"use client";
import {
  usePopoverArrow
} from "../__chunks/UFM3D5TN.js";
import "../__chunks/QFL5V2DO.js";
import {
  useTooltipContext
} from "../__chunks/3OMHZVJD.js";
import "../__chunks/TWDHCE7Y.js";
import "../__chunks/TE637IA7.js";
import "../__chunks/XXVAHUAO.js";
import "../__chunks/J55AVALY.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/5M6RSQEC.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/tooltip/tooltip-arrow.ts
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "div";
var useTooltipArrow = createHook(
  function useTooltipArrow2(_a) {
    var _b = _a, { store, size = 16 } = _b, props = __objRest(_b, ["store", "size"]);
    const context = useTooltipContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "TooltipArrow must be wrapped in a Tooltip component."
    );
    props = usePopoverArrow(__spreadValues({ store, size }, props));
    return props;
  }
);
var TooltipArrow = forwardRef(function TooltipArrow2(props) {
  const htmlProps = useTooltipArrow(props);
  return createElement(TagName, htmlProps);
});
export {
  TooltipArrow,
  useTooltipArrow
};
